<template>

  <v-row class="text-center" v-if="this.$store.state.toggleMenu">
    <v-col cols="12" class="d-flex justify-end" v-if="this.$store.state.restaurantInfo.social">
      <a :href="this.$store.state.restaurantInfo.social.facebook" v-if="this.$store.state.restaurantInfo.social.facebook" class="facebook social mr-2 mb-8"></a>
      <a :href="this.$store.state.restaurantInfo.social.tripadvisor" v-if="this.$store.state.restaurantInfo.social.tripadvisor" class="tripadvisor social mr-2 mb-8"></a>
      <a :href="this.$store.state.restaurantInfo.social.instagram" v-if="this.$store.state.restaurantInfo.social.instagram" class="instagram social mr-2 mb-8"></a>
      <a :href="'tel:'+this.$store.state.restaurantInfo.phone" v-if="this.$store.state.restaurantInfo.phone" class="phone social mr-2 mb-8"></a>
    </v-col>
    <v-col cols="12" class="text-center d-none" :class="{visible : this.$store.state.logoUrl}">
      <img :src="this.$store.state.logoUrl" id="restaurant-logo" />
    </v-col>
    <v-col cols="12" class="text-center my-6 d-none" :class="{visible : !this.$store.state.logoUrl}">
      <h1>{{this.$store.state.restaurantInfo.name}}</h1>
      <p class="text-caption">{{this.$store.state.restaurantInfo.subtitle}}</p>
    </v-col>
    <v-col cols="12" class="">
      <div v-for="(menu, index) in this.$store.state.menuList" :key="`menu-${index}`">
        <v-btn text block class="justified-btns secondary-color h2 mb-2 main-menu-btn" @click="currentMenu(menu); toggle();">
          {{ menu.title }}
          <v-icon class="next-icon"></v-icon>
        </v-btn>
      </div>
    </v-col>
  </v-row>

</template>

<script>

export default {
  name: "MainMenu",
  data() {
    return {
    };
  },
  methods: {
    toggle() {
      this.$store.commit('setToggleMenu');
      this.$store.commit('setToggleCat');
    },
    currentMenu(menu){
      this.$store.commit('setCurrentMenu', menu);
    }
  }
}
</script>
